import styles from 'components/runningText/runningText.module.css';
import { RunningText } from 'components/runningText/RunningText';
import { DIRECTION_LEFT } from 'components/runningText/constants';

const RunningTextComposition = () => {
    return (
        <div className={styles.runningTextBox}>
            <RunningText />
            <RunningText direction={DIRECTION_LEFT} />
        </div>
    );
};

export default RunningTextComposition;
